import api from '@/rest-api'

export default {
    // the card number and initials prove the visitor is that member (same check as the card login)
    getTransactionsByMember(memberId, card, initials) {
        return api.post(`/transaction/filtered`, {'member': memberId, 'card': card, 'initials': initials})
    },
    createTransaction(data) {
        return api.post(`/image/upload/transaction`, data)
    }
}